<template>
  <div class="refund_bg text_left">
    <title-bar-back :title="'申请售后'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <div
      v-for="(item, index) in getOptionalAfterOrder"
      :key="index"
      class="cart_list_c"
    >
      <!-- 退款商品店铺 -->
      <div class="font12 font_weight500 colo087 pac_name line_height_18">
        <img
          :src="item.isAllSelect ? activeIcon : inactiveIcon"
          alt=""
          class="active_icon"
          @click="clickBoxItemAll(index)"
        />
        <span class="name_name" @click="clickBoxItemAll(index)">{{
          item.parcelName
        }}</span>
      </div>
      <!-- 退款商品信息 -->
      <div
        v-for="(i, index1) in item.orderDetailList"
        :key="index1"
        class="refund_item"
      >
        <img
          v-if="!isUnPicked(item.subOrderSn)"
          :src="i.isSelect ? activeIcon : inactiveIcon"
          class="checkout_img"
          @click="clickBox(index1, index)"
        />
        <div v-else class="checkout_img_placeholder"></div>
        <div class="right_width">
          <order-product-list
            :item="i"
            :index="index"
            :index1="index1"
            :disabledNum="isUnPicked(item.subOrderSn)"
            @changeNum="changeNum"
          />
        </div>
      </div>
    </div>
    <div class="bottom_bor" />
    <div class="bottom_con font0">
      <div class="al_choose font12 font_weight400 colo087 line_height_20">
        已选（{{ chooseNum }}）
      </div>
      <div class="btn_r">
        <div class="font12 font_weight400 colo055 line_height_20">
          总计：
          <span class="colof00 font_weight500">{{
            chooseTotalMoney | currency(false)
          }}</span>
        </div>
        <div
          class="botton_btn text_center font14 font_weight500 colof line_height_20"
          @click="goChooseType"
        >
          申请售后
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
// const CartSection = () =>
//   import('~/components/Cart/CartSection.vue').then(m => m.default || m)
import OrderProductList from "../addproduct/components/Product";
export default {
  name: "AddProduct",
  components: {
    // CartSection,
    TitleBarBack,
    OrderProductList
  },
  data() {
    return {
      result: [],
      itemResult: {},
      checked: false,
      checkedItemAll: false,
      checkedAll: false,
      activeIcon: require("@/assets/login/select@2x.png"),
      inactiveIcon: require("@/assets/login/unselect@2x.png"),
      detail: {},
      refundProductList: [],
      addList: [],
      checkedPackageIndex: 0,
      isFirst: true
    };
  },
  computed: {
    getOptionalAfterOrder() {
      const getOptionalAfterOrder = this.$store.getters.getOptionalAfterOrder;
      return getOptionalAfterOrder;
    },
    chooseNum() {
      if (!this.isFirst) {
        const getOptionalAfterOrder = this.getOptionalAfterOrder;
        const { orderDetailList } = getOptionalAfterOrder[
          this.checkedPackageIndex
        ];
        const b = orderDetailList.filter(i => i.isSelect);
        const cc = b.reduce((sum, item) => sum + item.modifyNum, 0);
        return cc;
      } else {
        return 0;
      }
    },
    chooseTotalMoney() {
      if (!this.isFirst) {
        const getOptionalAfterOrder = this.getOptionalAfterOrder;
        const { orderDetailList } = getOptionalAfterOrder[
          this.checkedPackageIndex
        ];
        const b = orderDetailList.filter(i => i.isSelect);
        const cc = b.reduce(
          (sum, item) =>
            (sum += (item.skuNowPrice + item.skuTax) * item.modifyNum),
          0
        );
        return cc;
      } else {
        return 0;
      }
    }
  },
  watch: {
    getOptionalAfterOrder: {
      handler(newVal, oldVal) {
        console.log(newVal, oldVal);
      },
      deep: true
    }
  },
  created() {
    this.getData();
  },
  methods: {
    // getOptionalAfterOrder
    getData() {
      // console.log("获取数据");
      this.$store
        .dispatch("order/getOptionalAfterOrder", {
          params: { orderSn: this.$route.query.orderSn }
        })
        .then(() => {
          this.isFirst = false;
        })
        .catch(() => {});
    },
    // 顶部返回
    back() {
      this.$router.back(-1);
    },
    goChooseType() {
      //  存储数据
      const filterAllList = this.getOptionalAfterOrder.filter(item => {
        return item.orderDetailList.filter(item => item.isSelect);
      });
      const filterList = filterAllList[
        this.checkedPackageIndex
      ].orderDetailList.filter(item => item.isSelect);
      filterList.forEach(item => {
        if (!item.modifyNum) {
          item.modifyNum = item.skuAmount;
        }
      });
      // console.log(filterList, "filterList");
      if (filterList && filterList.length === 0) {
        this.$toast("请选择售后商品");
        return;
      }
      const refundList = JSON.parse(JSON.stringify(filterList));
      localStorage.setItem("mall-wap-refund-list", JSON.stringify(refundList));
      localStorage.setItem("mall-wap-refund-type", this.$route.query.orderType);
      this.$router.push({
        path: "/order/refund/chooserefundtype",
        query: {
          orderType: this.$route.query.orderType,
          subOrderSn: filterAllList[this.checkedPackageIndex].subOrderSn,
          orderSn: this.$route.query.orderSn
        }
      });
    },
    // 点击数量
    changeNum(num, index, index1) {
      const { orderDetailList } = this.getOptionalAfterOrder[index];
      let currentItem = orderDetailList[index1];
      currentItem.modifyNum = num;
      this.$set(orderDetailList, index1, currentItem);
      // console.log(22222, orderDetailList);
    },
    isUnPicked(subOrderSn) {
      return subOrderSn && subOrderSn.includes("UNPICKED");
    },
    clearPackageChecked(index) {
      const { orderDetailList } = this.getOptionalAfterOrder[index];
      const currentItem = this.getOptionalAfterOrder[index];
      currentItem.isAllSelect = false;
      orderDetailList.forEach(item => {
        item.isSelect = false;
      });
    },
    // 单选
    clickBox(index1, index) {
      if (this.isUnPicked(this.getOptionalAfterOrder[index].subOrderSn)) {
        return;
      }
      // console.log(index);
      if (this.checkedPackageIndex !== index) {
        // 清空之前选中的其他包裹的选中的状态
        this.clearPackageChecked(this.checkedPackageIndex);
        this.checkedPackageIndex = index;
      }
      const { orderDetailList } = this.getOptionalAfterOrder[index];
      let currentItem = orderDetailList[index1];
      currentItem.isSelect = !currentItem.isSelect;
      if (!currentItem.modifyNum) {
        currentItem.modifyNum = currentItem.skuAmount;
      }
      this.$set(
        this.getOptionalAfterOrder[index].orderDetailList,
        index1,
        currentItem
      );
      this.chooseItem(index);
    },
    clickBoxItemAll(index) {
      if (this.checkedPackageIndex !== index) {
        // 清空之前选中的其他包裹的选中的状态
        this.clearPackageChecked(this.checkedPackageIndex);
        this.checkedPackageIndex = index;
      }
      const currentItem = this.getOptionalAfterOrder[index];
      currentItem.isAllSelect = !currentItem.isAllSelect;
      if (!currentItem.isAllSelect) {
        currentItem.orderDetailList.forEach(item => {
          item.isSelect = false;
          if (!item.modifyNum) {
            item.modifyNum = item.skuAmount;
          }
        });
      } else {
        currentItem.orderDetailList.forEach(item => {
          item.isSelect = true;
          if (!item.modifyNum) {
            item.modifyNum = item.skuAmount;
          }
        });
      }
      this.$set(this.getOptionalAfterOrder, index, currentItem);
    },
    // 单选是否全部选中
    chooseItem(index) {
      const currentItem = this.getOptionalAfterOrder[index];
      const { orderDetailList } = currentItem;
      const checkList = orderDetailList.filter(item => item.isSelect);
      if (orderDetailList && orderDetailList.length === checkList.length) {
        currentItem.isAllSelect = true;
        this.$set(this.getOptionalAfterOrder, index, currentItem);
      } else {
        currentItem.isAllSelect = false;
        this.$set(this.getOptionalAfterOrder, index, currentItem);
      }
    }
  }
};
</script>

<style scoped>
.title_right {
  width: 36px;
}
/* 侧滑 */
.cart_list_c {
  background: #fff;
  border-radius: 10px;
}
.pac_name {
  padding: 20px 12px;
}
.active_icon {
  width: 18px;
  margin-right: 8px;
  vertical-align: middle;
}
.name_name {
  vertical-align: middle;
}
.right_delete {
  background: rgba(242, 11, 0, 1);
  height: 100%;
  width: 64px;
  cursor: pointer;
}
.right_delete_btn {
  position: absolute;
  width: 100%;
  top: 50%;
  margin-top: -25%;
  text-align: center;
  color: #fff;
  font-size: 14px;
}
.refund_item {
  display: flex;
  align-items: center;
  padding-bottom: 4px;
}
.right_width {
  width: 100%;
  margin-right: 12px;
}
.bottom_bor {
  height: 72px;
}
/* 底部按钮 */
/* .bottom_con {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: 5px 15px;
}
.checkout_all {
  width: 20px;
  height: 20px;
  margin-top: 10px;
}
.bot_mar {
  margin: 12px 0 0 5px;
}
.choose_btn {
  background: linear-gradient(
    270deg,
    rgba(251, 214, 146, 1) 0%,
    rgba(224, 175, 101, 1) 100%
  );
  border-radius: 20px;
  font-size: 15px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 40px;
  padding: 0 40px;
} */
.checkout_img {
  width: 18px;
  height: 18px;
  margin: 0 12px;
}
.checkout_img_placeholder {
  width: 18px;
  height: 18px;
  margin: 0 12px;
  flex-shrink: 0;
}
.bottom_con {
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
}
.al_choose {
  padding-left: 12px;
}
.btn_r {
  display: flex;
  align-items: center;
}
.botton_btn {
  background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
  border-radius: 2px;
  padding: 20px 21px;
  margin-left: 4px;
}
</style>
